module.exports = __webpack_public_path__ + "static/christian_sec3-fc42df08967864c28bd3f9461db3e630.png";